import { render, staticRenderFns } from "./QualityAssuranceLabelApprove.vue?vue&type=template&id=693f377f"
import script from "./QualityAssuranceLabelApprove.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabelApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports